function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Contract = function Contract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M4.16 3.83c0-.593.481-1.07 1.07-1.07h13.55c.593 0 1.07.482 1.07 1.07v.325a1.52 1.52 0 0 0-1.302.892L13.46 15.953l-.01.022a1.55 1.55 0 0 0-.11.883l.309 1.897c.162 1.084 1.377 1.638 2.307 1.078l.002-.001 1.656-.988a1 1 0 0 0 .097-.069c.229-.161.385-.37.49-.58l.009-.018 1.64-3.516V20.1c0 .67-.498 1.13-1.07 1.13H5.23a1.07 1.07 0 0 1-1.07-1.07zm17.19 7.616V20.1c0 1.47-1.143 2.63-2.57 2.63H5.23a2.57 2.57 0 0 1-2.57-2.57V3.83a2.57 2.57 0 0 1 2.57-2.57h13.55a2.57 2.57 0 0 1 2.57 2.57v.824l1.204.565a1.53 1.53 0 0 1 .745 2.05zm-1.17-5.684a.8.8 0 0 0 .21.098l1.531.72.011.004.01.006.004.008.002.012q0 .005-.006.018l-5.086 10.903-.013.02a1 1 0 0 0-.08.054l-1.577.94-.004.003a.04.04 0 0 1-.017.006.04.04 0 0 1-.018-.004l-.012-.008-.001-.002v-.002l-.002-.006-.312-1.922-.002-.01q.001-.007.008-.027L19.91 5.677l.004-.01.006-.009.008-.004.011-.002q.006 0 .02.006zM7.22 7.15a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5zm-.75 4.95a.75.75 0 0 1 .75-.75h5.26a.75.75 0 0 1 0 1.5H7.22a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  }));
};
export default Contract;
Contract.displayName = 'Contract';